import type { VignetteDefinition } from "./types";

/**
 * Holiday vignette — Johnny is startled by the jack-o-lantern
 * EnvironmentDecorator has placed on the sand. "HitRecieve" (a short
 * flinch/reaction clip from the sourced library) stands in for a dedicated
 * reaction animation, looped for a slightly comedic repeated startle.
 */
export const halloweenVignette: VignetteDefinition = {
  id: "halloween",
  name: "A jack-o-lantern appears",
  category: "holiday",
  weight: 1, // irrelevant — holiday vignettes bypass weighted selection (see SceneDirector)
  animationClip: "HitRecieve",
  loopAnimation: true,
  durationMs: 4000,
  cameraFraming: {
    offset: { x: -2.2, y: 2, z: 1.8 },
    targetOffset: { x: 1.4, y: 0.5, z: -0.6 },
  },
  dateWindow: { startMonth: 10, startDay: 24, endMonth: 11, endDay: 1 },
  audioCues: [],
  onEnter: (ctx) => ctx.decorator.setHoliday("halloween"),
  onExit: (ctx) => ctx.decorator.setHoliday(null),
};
